import React, { useState, useEffect } from 'react';

/**
 * =====================================================
 * 🆕 Nouvelle interface
 * =====================================================
 */
import NewUI from "./NewUI";

/**
 * =====================================================
 * 📦 Import des composants existants (inchangés)
 * =====================================================
 */
import Transactions from './components/Transactions';
import AddTransaction from './components/AddTransaction';
import ImportCSV from './components/ImportCSV';
import Dashboard from './components/Dashboard';
import ExpensesChart from './components/ExpensesChart';
import Merchants from './components/Merchants';
import Budget from './components/Budget';
import Categories from './components/Categories';
import CashBalance from './components/CashBalance';
import BudgetPlanner from './components/BudgetPlanner';

function App() {

  /**
   * 🔄 Clé globale de refresh
   */
  const [refreshKey, setRefreshKey] = useState(0);

  /**
   * 📅 Mois sélectionné
   */
  const [selectedMonth, setSelectedMonth] = useState(() => {
    const savedMonth = localStorage.getItem("selectedMonth");
    return savedMonth || new Date().toISOString().slice(0, 7);
  });

  /**
   * 🧭 Page active
   */
  const [activePage, setActivePage] = useState("budget");

  useEffect(() => {
    localStorage.setItem("selectedMonth", selectedMonth);
  }, [selectedMonth]);

  const handleGlobalUpdate = () => {
    setRefreshKey(prev => prev + 1);
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    setRefreshKey(prev => prev + 1);
  };

  /**
   * =====================================================
   * ⭐ IMPORTANT : On affiche la nouvelle UI uniquement
   * =====================================================
   */

  return <NewUI />;

}

export default App;
